module.exports = __webpack_public_path__ + "static/media/6.462955ae.jpg";